module.exports = __webpack_public_path__ + "static/img/demoImageB1.63a3aea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demoImageB1.png
// module id = zX8h
// module chunks = 3